import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchWithResponse } from '@e3dc-react/shell/Types'
import { EmsSgReadyStatus } from 'src/Libs/dynamic-power-prices/types'
import { fromEmsSgReadyStatusDtoToModel } from '../transformer'

export type EmsSgReadyModeDto = 'END' | 'STATE 1 BLOCK' | 'STATE 2 NORMAL' | 'STATE 3 GO' | 'STATE 4 FORCE GO' | 'UNKNOWN'
export interface EmsSgReadyStatusDTO {
  state: EmsSgReadyModeDto
  disabled: boolean
}

export const getSgReadyStatus = async (storageId: string | undefined, authFetch: AuthFetchWithResponse): Promise<EmsSgReadyStatus | null> => {
  if (!storageId) return null
  try {
    const response = await authFetch<EmsSgReadyStatusDTO>({
      path: `storages/${storageId}/powermeter-values/${255}/sg-ready`, // 255 needs to be hard-coded for unknown reasons
    })

    if (response.status === StatusCodes.OK) return fromEmsSgReadyStatusDtoToModel(response.data)
    else {
      console.error(`unknown status code ${response.status} while fetching sg ready status for storage ${storageId}`, response)
      return null
    }
  } catch (error) {
    console.error('Failed to fetch sg ready status: ' + (error as Error).message)
    return null
  }
}
